import React from 'react';

import { Inline, Stack } from '@atlaskit/primitives/compiled';
import HeadingSkeleton from '@atlaskit/skeleton';

import { CardList } from '../../../common/ui/CardList/CardList';
import { AgentCardSkeleton } from '../../agent-card/components/AgentCardSkeleton';

export const CardListSkeleton = ({
	count,
	showHeading = false,
	testId,
}: {
	count: number;
	showHeading?: boolean;
	testId?: string;
}): React.JSX.Element => {
	const skeletonKeys = Array.from({ length: count }, (_, index) => `skeleton-card-${index}`);

	return (
		<Stack space="space.200">
			{showHeading ? (
				<Inline alignBlock="center">
					<HeadingSkeleton width={80} height={20} isShimmering />
				</Inline>
			) : null}
			<CardList testId={testId}>
				{skeletonKeys.map((key, index) => (
					<AgentCardSkeleton key={key} testId={testId ? `${testId}--card-${index}` : undefined} />
				))}
			</CardList>
		</Stack>
	);
};
